import InteractionService from '../../../services/interaction_service';

const Scores = (vm) => {
  const handleScoreChange = (id, newScore) => {
    vm.setEditedScores((prevScores) => ({
      ...prevScores,
      [id]: newScore,
    }));
  };

  const handleSaveAllScores = async () => {
    vm.setLoadingUpdate(true);
    try {
      const updatedInteractions = Object.entries(vm.editedScores).filter(([id, newScore]) => {
        const interaction = vm.interactions.find((item) => item.Id === id);
        return interaction && newScore !== interaction.Score;
      });
      for (const [id, newScore] of updatedInteractions) {
        await InteractionService.update(id, { Score: newScore });
      }
      await vm.message?.('Puntajes actualizados exitosamente', 'success');
      await vm.fetchInteractions();
    } catch (e) {
      vm.message(e?.message || e, "error");
    } finally {
      vm.setLoadingUpdate(false);
    }
  };

  const deleteChange = () => {
    const restoredScores = vm.interactions?.reduce((acc, interaction) => {
      acc[interaction?.Id] = Math.floor(interaction?.Score);
      return acc;
    }, {});
    vm.setEditedScores(restoredScores || {});
  };

  return {
    handleScoreChange,
    handleSaveAllScores,
    deleteChange,
  };
};

export default Scores;
